<template>
  <div class="Empty">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyPlace"
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.Empty {
  margin: 3rem 0;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 3rem 0;

    p {
      margin: 0 0 50px;
      font-size: 24px;
      font-weight: $b_fw;
    }
  }

  &__image {
    width: 50%;
  }
}
</style>
